export const filterFieldSizeMap = {
  revenue: {
    allCompanies: 4,
    singleCompany: 6
  },
  expense: {
    allCompanies: 2,
    singleCompany: 2.4
  }
};
